import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product} from "../../../../store/state/order.state";
import {ChangeSet, TransferQuestionsChanges} from "../../history/order-history.model";
import {TranslationsHelperService} from "../../../translations/translations-helper.service";

@Component({
    selector: 'transfer-additional-questions-details',
    templateUrl: './transfer-additional-questions-details.template.html',
    styleUrls: ['./transfer-additional-questions-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TransferAdditionalQuestionsDetailsComponent {

	readonly RANDOM_NUMBER: number = Math.random();

	@Input() product: Product;
	@Input() changeSet: ChangeSet;	// optional
	@Input() translateClientsData;
	@Input() useOriginalTranslations: boolean;

	constructor(public translationsHelper: TranslationsHelperService) {
	}

	isDesiredNextAuditDateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.additionalQuestionsChanges().desiredNextAuditDate;
	}

	isTransferReasonChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().transferReason;
	}

	isCbAccreditedChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().isCurrentCertificationBodyAccredited;
	}

	areOpenNonConformitiesChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().hasOpenNonConformities;
	}

	isCorrectivePlansChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().hasCorrectiveActionPlans;
	}

	areMajorNonConformitiesChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().numberOfMajorNonConformities;
	}

	areMinorNonConformitiesChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().numberOfMinorNonConformities;
	}

	isLastAudiPerformedChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().lastAuditPerformedDate;
	}

	isExpirationDateChanged(): boolean {
		return !!this.changeSet && this.additionalQuestionsChangesPresent() && !!this.transferQuestionChanges().expirationDate;
	}

	private transferQuestionChanges(): TransferQuestionsChanges {
		return this.additionalQuestionsChanges().transferQuestionsChanges;
	}

	private additionalQuestionsChanges() {
		return this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}

	private additionalQuestionsChangesPresent() {
		return !!this.changeSet.changes.productChanges[this.product.standard.name] && !!this.changeSet.changes.productChanges[this.product.standard.name].additionalQuestions;
	}
}
